import { createAction } from 'deox';

import { ResponseError } from 'modules/errors';

import { GetCompaniesQueryParams, GetCompaniesResponse } from 'types';

export const getCompanies = {
  request: createAction(
    'companies/GET_COMPANIES',
    (resolve) => (payload: GetCompaniesQueryParams) => resolve(payload),
  ),
  success: createAction(
    'companies/GET_COMPANIES_SUCCESS',
    (resolve) => (payload: GetCompaniesResponse) => resolve(payload),
  ),
  fail: createAction('companies/GET_COMPANIES_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};
